module.exports = __webpack_public_path__ + "img/土鳖虫.619d9f2b.jpg";